import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { FaFacebookSquare, FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selected, setSelected] = useState("inicio");

  const navLinks = [
    { text: "Inicio", href: "inicio" },
    { text: "Nosotros", href: "nosotros" },
    { text: "Servicios", href: "servicios" },
    { text: "Contacto", href: "contacto" },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);

    if (target) {
      setMenuOpen(false); // Cerrar menú antes de hacer scroll
      setTimeout(() => {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.pushState(null, "", `#${targetId}`); // Evita salto brusco
      }, 400);
    }
    setSelected(targetId);
  };

  useEffect(() => {
    const hash = window.location.hash.substr(1);
    if (hash) {
      setTimeout(() => handleSmoothScroll(new Event("click"), hash), 100);
    }
  }, []);

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 w-full z-40"
    >
      <motion.div
        animate={{
          backgroundColor: scrolled
            ? "rgba(255, 255, 255, 1)"
            : "rgba(255, 255, 255, 0)",
          boxShadow: scrolled ? "0px 4px 6px rgba(0, 0, 0, 0.1)" : "none",
        }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
        className="w-full"
      >
        <div
          className={`w-full text-white p-3 bg-[#23346E] ${
            scrolled ? "!hidden" : "md:!block hidden"
          }`}
        >
          <div className="max-w-screen-2xl flex justify-between mx-auto">
            <div className="flex gap-4">
              <div className="flex justify-center items-center gap-2">
                <FaPhoneAlt />
                <span>Llámenos : 631-209-1989</span>
              </div>
              <div className="flex justify-center items-center gap-2">
                <MdEmail />
                <span>Correo: contacto@seguridadbp.com</span>
              </div>
            </div>
            <div>
              <a href="https://www.facebook.com/BorderProtect.Seguridad">
                <FaFacebookSquare className="w-full h-full" />
              </a>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center max-w-screen-2xl mx-auto h-24 px-4">
          <div className="flex items-center h-full">
            <img
              src="/img/logo/logo.png"
              alt="logo border protect seguridad privada"
              className="h-20 w-auto p-3"
            ></img>
            <h1 className={`text-3xl font-bold mt-10 mb-10 ${scrolled ? " text-neutral-700" : "text-white"}`}>
              Border Protect
            </h1>
          </div>
          <nav className="hidden md:flex relative gap-10">
            {navLinks.map((link) => (
              <div
                key={link.text}
                className="relative flex flex-col items-center"
              >
                <a
                  href={`#${link.href}`}
                  onClick={(e) => handleSmoothScroll(e, link.href)}
                  className={`text-base relative z-10 py-2 transition-all cursor-pointer ml-2 mr-2 uppercase  ${
                    selected === link.href
                    ? scrolled
                      ? "text-black font-bold"
                      : "text-white font-bold"
                      : scrolled
                      ? "text-gray-600 hover:text-[#0a2540]"
                      : "text-gray-300 hover:text-white"
                  }`}
                >
                  {link.text}
                </a>
              </div>
            ))}
          </nav>

          <div className="md:flex justify-center items-center gap-2 text-lg hidden">
            <FaPhoneAlt className={` ${scrolled ? "  text-[#23346E]" : "text-red-600"}`}/>
            <span
              className={`font-bold ${
                scrolled ? "!text-black " : "!text-white"
              }`}
            >
              631-209-1989
            </span>
          </div>
          <button
            className="md:hidden p-2 text-black"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? (
              <XMarkIcon className="h-8 w-8" />
            ) : (
              <Bars3Icon className="h-8 w-8" />
            )}
          </button>
        </div>

        <motion.div
          initial={{ height: 0 }}
          animate={{ height: menuOpen ? "auto" : 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className={`md:hidden bg-white shadow-md overflow-hidden`}
        >
          <ul className="flex flex-col items-center space-y-4 py-6">
            {navLinks.map((link) => (
              <li key={link.text}>
                <a
                  href={`#${link.href}`}
                  onClick={(e) => handleSmoothScroll(e, link.href)}
                  className="text-gray-700 font-semibold text-lg hover:text-blue-700 transition"
                >
                  {link.text}
                </a>
              </li>
            ))}
          </ul>
        </motion.div>
      </motion.div>
    </motion.header>
  );
}
